import React, {useEffect, useState} from "react";
import {usePage} from "@inertiajs/react";
import SharedAccountHint from "./SharedAccountHint.jsx";

// Session-Merker: verhindert, dass der Hinweis bei jedem Seitenwechsel
// (Inertia-Navigation liefert bei jedem Aufruf erneut isSharedSupportAccount)
// wieder aufgeht. sessionStorage überlebt Seitenwechsel innerhalb derselben
// Anmeldung, aber nicht das Schließen des Browser-Tabs - genau das
// "einmal pro Sitzung" aus der Aufgabenstellung.
const SESSION_STORAGE_KEY = "supportSharedAccountNoticeShown";

/**
 * Zeigt einmal pro Sitzung einen Hinweis, wenn mit dem Sammelzugang der
 * Probearbeiter angemeldet wurde - unabhängig davon, ob der Support-Knopf
 * angeklickt wird (siehe SharedAccountHint für den Text). Global in
 * GlobalControls.jsx eingehängt, damit die Prüfung unabhängig von der
 * gerade aufgerufenen Seite läuft.
 */
export default function SharedAccountLoginNotice() {
    const {isSharedSupportAccount} = usePage().props;
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (!isSharedSupportAccount) {
            return;
        }

        let alreadyShown = false;
        try {
            alreadyShown = window.sessionStorage.getItem(SESSION_STORAGE_KEY) === "1";
        } catch (e) {
            // Privater Modus o. ä. ohne sessionStorage - dann lieber einmal
            // zu oft zeigen als den Hinweis stillschweigend zu verlieren.
        }

        if (!alreadyShown) {
            setShow(true);
        }
        // Nur beim ersten Mount dieser Komponente prüfen - danach entscheidet
        // ausschließlich das Schließen (close()) über das Verschwinden.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const close = () => {
        setShow(false);
        try {
            window.sessionStorage.setItem(SESSION_STORAGE_KEY, "1");
        } catch (e) {
            // s. o.
        }
    };

    if (!isSharedSupportAccount) {
        return null;
    }

    return <SharedAccountHint show={show} onClose={close} />;
}
